module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fzg-chuangtou-mobile"
  }, [_c('div', {
    staticClass: "fzg-banner"
  }, [_c('fzg-menu'), _vm._v(" "), _c('img', {
    staticClass: "m-banner",
    attrs: {
      "src": require("../../assets/img2/mobile/invest/banner.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "m-intro",
    attrs: {
      "src": "https://static-image.xfz.cn/1698581100360/chuangtou_mobile.jpg"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fzg-ct-case-list"
  }, [_c('img', {
    staticClass: "case-title",
    attrs: {
      "src": require("../../assets/img2/pc/chuangtou/title-al.png")
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "bus-wrap"
  }, [_vm._l((_vm.invest_case_list), function(item) {
    return _c('li', {
      staticClass: "bus-item"
    }, [_c('div', {
      staticClass: "cover"
    }, [_c('div', {
      staticClass: "cover-content"
    }, [_vm._v(" " + _vm._s(item.brief) + " ")])]), _vm._v(" "), _c('img', {
      staticClass: "logo",
      attrs: {
        "src": item.logo,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])])
  }), _vm._v(" "), (false) ? [_vm._m(0, false, false)] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "fzg-company-list"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "fzg-company-list-wrap"
  }, [_vm._l((_vm.invest_company_list), function(item, index) {
    return (_vm.isShowMoreCompany ? true : index < 7) ? _c('div', {
      staticClass: "fzg-company-list-item-wrap",
      class: {
        'active-company': _vm.activeCompanyId == item.id
      }
    }, [_c('div', {
      staticClass: "fzg-citem",
      on: {
        "click": function($event) {
          _vm.activeCompanyId = item.id
        }
      }
    }, [_c('div', {
      staticClass: "citem-name"
    }, [_c('div', {
      staticClass: "c-title"
    }, [_vm._v(" " + _vm._s(item.name) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "c-item-content"
    }, [_c('div', {
      staticClass: "c-item-image"
    }, [_c('img', {
      attrs: {
        "src": item.logo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "c-item-intro"
    }, [_c('p', [_vm._v(_vm._s(item.brief))]), _vm._v(" "), _c('div', {
      staticClass: "c-item-link"
    }, [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_vm._v(" 查看企业 ")])])])])])]) : _vm._e()
  }), _vm._v(" "), (!_vm.isShowMoreCompany) ? _c('div', {
    staticClass: "check-more",
    on: {
      "click": function($event) {
        _vm.isShowMoreCompany = true
      }
    }
  }, [_vm._v(" 更多 ")]) : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "bus-item"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('div', {
    staticClass: "cover-content"
  }, [_vm._v(" 新一代经营门店经营系统，助力商家数字化升级 ")])]), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/chuangfu/logo10.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("人才对接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-list-title"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img2/pc/chuangtou/title-bt.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-972d339a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/investment/FzgChuangTouMobile.vue
// module id = 237
// module chunks = 0